export enum TabsOrientation {
  horizontal = 'horizontal', // default
  vertical = 'vertical',
}

export enum TabsTextTransform {
  uppercase = 'uppercase',
  none = 'none', // default
}
